import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { RootState, store } from "redux/store";
import { useHistory } from "react-router-dom";
import commonStyle from "assets/jss/common/common";
import Button from 'components/CustomButtons/Button';
import PropTypes from 'prop-types'
import { useSelector } from "react-redux";
import { login as loginAction, logout as logoutAction } from 'redux/reducers/user'
import { setHeaderMode, setRedirectPath } from 'redux/reducers/appstate'
import { useIsAuthenticated } from "hooks/userHook";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, ButtonBase } from "@mui/material";
import WebTranslateText from "Utils/Translation/WebTranslateText";

export const isLogin = () => {
  const user = store.getState().user;
  const now = Date.now();

  if (user.IS_LOGGED_IN && user.EXPIRES_ON > now / 1000) {
    return true
  } else {
    return false
  }
}
export const login = (data) => {
  store.dispatch(loginAction(data))
}
export const logout = () => {
  store.dispatch(logoutAction())
  // store.dispatch(setHeaderMode("investor"))
}
export const getProfile = () => {
  const state = store.getState();
  return state.user.PROFILE
}
export const RedirectAuth = (history, path = 'https://app.actelligent-capital.com/auth/signup') => {
  const current_location = window.location.href
  store.dispatch(setRedirectPath(current_location))
  window.open(path)
}
function Auth(props) {

  if (!isLogin()) {
    return <Redirect to={"https://app.actelligent-capital.com/auth/signup"} />
  }
  return props.children;
}

export const AuthView = (props) => {
  const history = useHistory()
  const { title } = props
  const isAuthenticated = useIsAuthenticated()
  if (!isAuthenticated) {
    return <Box sx={{ py: '1rem' }}><ButtonBase 
        sx={{ fontSize: '1rem' }}
        onClick={() => RedirectAuth(history)}
      >
        {title}
      </ButtonBase></Box>
  } else {
    return props.children
  }
}

AuthView.defaultProps = {
  title: <Box sx={{ display: 'flex', alignItems: 'center' }}><LockOutlinedIcon sx={{ width: '1.5 rem', height: '1.5rem', mr: '0.5rem' }} /> <WebTranslateText text='Authentication required. Please log in or sign up to view this section.' part="General" /></Box>
}
AuthView.propTypes = {
  title: PropTypes.node
}
export default (Auth);